import React, { useState } from 'react';
import { signIn } from 'aws-amplify/auth';
import { useDispatch } from 'react-redux';
import FormCard from '../shared/FormCard';
import TabNavigation from '../shared/TabNavigation';
import { updateUserInRedux } from '../../../utils/updateUserInRedux';
import ForgotPassword from '../../shared/ForgotPassword';
import PasswordInput from '../../ui/PasswordInput';

const ProdytSignIn = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotForm, setShowForgotForm] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await signIn({
        username: email,
        password: password,
      });

      await updateUserInRedux(dispatch);
    } catch (err) {
      if (err.name === 'UserNotConfirmedException') {
        setError('Please verify your email before signing in');
      } else if (err.name === 'NotAuthorizedException') {
        setError('Invalid email or password');
      } else if (err.name === 'UserNotFoundException') {
        setError('Account not found. Please sign up first');
      } else {
        setError(err.message || 'Failed to sign in');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setShowForgotForm(true);
  };

  return (
    <FormCard>
      {/* Header */}
      <div style={{ marginBottom: '24px', textAlign: 'center' }}>
        <h2 style={{
          margin: '0 0 8px 0',
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#1f2937'
        }}>
          Sign In to CRM
        </h2>
        <p style={{
          margin: '0',
          fontSize: '14px',
          color: '#6b7280'
        }}>
          Manage warranties and complaints
        </p>
      </div>

      {/* Tab Navigation */}
      <div style={{ marginBottom: '24px' }}>
        <TabNavigation />
      </div>

      {/* Error Message */}
      {!showForgotForm && error && (
        <div style={{
          marginBottom: '16px',
          padding: '12px',
          background: '#fee2e2',
          border: '1px solid #fca5a5',
          borderRadius: '6px',
          color: '#dc2626',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}

      {/* Sign In Form */}
      {!showForgotForm && (
        <form onSubmit={handleSignIn}>
        {/* Email Field */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151'
          }}>
            Email
          </label>
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: '12px', top: '10px', color: '#9ca3af' }}>✉️</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@company.com"
              required
              style={{
                width: '100%',
                padding: '10px 12px',
                paddingLeft: '38px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box',
                backgroundColor: '#f9fafb'
              }}
            />
          </div>
        </div>

        {/* Password Field */}
        <div style={{ marginBottom: '8px' }}>
          <PasswordInput
            label="Password"
            id="prodyt-signin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            disabled={isLoading}
            labelStyle={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151'
            }}
          />
        </div>

        {/* Forgot Password */}
        <div style={{
          marginBottom: '24px',
          textAlign: 'right'
        }}>
          <button
            type="button"
            onClick={handleForgotPassword}
            style={{
              background: 'none',
              border: 'none',
              color: '#2563eb',
              cursor: 'pointer',
              fontSize: '14px',
              textDecoration: 'none'
            }}
          >
            Forgot password?
          </button>
        </div>

        {/* Sign In Button */}
        <button
          type="submit"
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: isLoading ? '#9ca3af' : '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s ease'
          }}
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
      )}

      {showForgotForm && (
        <ForgotPassword onClose={() => setShowForgotForm(false)} />
      )}
    </FormCard>
  );
};

export default ProdytSignIn;
